import Request from '../Request';
import EndPoints from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param token
 * @return {Promise<any>|Promise}
 */
export default (function (token) {
    var headers = { 'Content-Type': 'application/json' };
    var request = new Request({
        method: Methods.POST,
        url: EndPoints.CONFIRM_REGISTRATION,
        withCredentials: false,
        headers: headers,
        data: JSON.stringify(token)
    });
    return request.execute();
});
